import { useStatsigLayer } from '@/hooks';
import { useMyParcelsContext } from '@/modules/pmt/context';

// The pop-up only opens right after a Google sign-in, so it is read from the signed-in layer only
export const useGrantAccessPopupCopy = () => {
  const { trackingTranslation } = useMyParcelsContext();
  const { get, isReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const { mainTextGrantAccessPopup, subTextGrantAccessPopup, mainButtonGrantAccessPopup } = trackingTranslation;

  const fallback = {
    mainText: mainTextGrantAccessPopup ?? '',
    subText: subTextGrantAccessPopup ?? '',
    cta: mainButtonGrantAccessPopup ?? '',
  };

  if (!isReady) return fallback;

  // Empty by default so the CMS copy stays in place when the experiment does not set it
  return {
    mainText: get('grant_access_main_text', '').trim() || fallback.mainText,
    subText: get('grant_access_subtext', '').trim() || fallback.subText,
    cta: get('grant_access_cta', '').trim() || fallback.cta,
  };
};
